"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const links = [
  { href: "/dashboard/investment", label: "Overview" },
  { href: "/dashboard/investment/rounds", label: "Rounds" },
  { href: "/dashboard/investment/actuals", label: "Monthly Actuals" },
  { href: "/dashboard/investment/mailing", label: "Mailing" },
  { href: "/dashboard/investment/email-templates", label: "Email Templates" },
  { href: "/dashboard/investment/ticket-purchases", label: "Ticket Purchases" },
  { href: "/dashboard/investment/historical-tickets", label: "Historical Tickets" },
  { href: "/dashboard/investment/ticket-types", label: "Ticket Types" },
  { href: "/dashboard/investment/ledger", label: "Ledger" },
  { href: "/dashboard/investment/fx-rates", label: "FX Rates" },
  { href: "/dashboard/investment/certificates", label: "Certificates" },
];

export default function InvestmentLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  return (
    <div className="grid grid-cols-1 gap-6 px-4 sm:px-6 md:grid-cols-[220px_minmax(0,1fr)] md:px-0">
      <aside className="bg-white border rounded-lg p-3 h-fit">
        <h2 className="text-sm font-semibold text-gray-900 px-2 py-1">Investment</h2>
        <nav className="mt-2 space-y-1">
          {links.map((link) => {
            const active = pathname === link.href || pathname?.startsWith(`${link.href}/`);
            return (
              <Link
                key={link.href}
                href={link.href}
                className={`block rounded-md px-3 py-2 text-sm ${
                  active ? "bg-blue-50 text-blue-700 font-medium" : "text-gray-700 hover:bg-gray-50"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>
      </aside>
      <section className="min-w-0">{children}</section>
    </div>
  );
}
